@if (selectedField?.type === 'string') {
  @if (!compareBlank) {
    <div class="select-search-field">
        <input matInput [(ngModel)]="rule.value" (ngModelChange)="valueChanged.emit()"
          placeholder="Input criteria"/>
    </div>
  }
}

@if (selectedField?.type === 'number') {
  @if (!compareBlank) {
    <div class="select-search-field" style="text-align: right;">
        <input matInput type="number" step="any" [(ngModel)]="rule.value" (ngModelChange)="valueChanged.emit()" />
    </div>
  }
}

@if (selectedField?.type === 'category') {
  @if (!compareBlank) {
    <div class="select-search-field">
        <mat-form-field class="no-label">
          <mat-select [(ngModel)]="rule.value" (ngModelChange)="valueChanged.emit()">
            @for (opt of selectedField.options; track opt.value) {
              <mat-option [value]="opt.value">
                {{opt.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
    </div>
  }
}

@if (selectedField?.type === 'dropdown') {
  @if (!compareBlank) {
    <div class="select-search-field">
        <select-filter
          (constant_changed)="rule.value = $event; valueChanged.emit()"
          [modelValue]="rule.value"
          [placeholder]="'Select option'"
          [options]="selectedField.options"
          [classes]="'fill'">
        </select-filter>
    </div>
  }
}

@if (selectedField?.type === 'datetime' || selectedField?.type === 'date') {
  @if (!compareBlank) {
    <div class="select-search-field">
        <date-time-picker
          (date_changed)="rule.value = $event.toISOString(); valueChanged.emit()"
          [input_date]="rule.value"
        ></date-time-picker>
    </div>
  }
}

@if (selectedField?.type === 'boolean') {
  @if (!compareBlank) {
    <div class="select-search-field">
        <mat-checkbox [(ngModel)]="rule.value" (ngModelChange)="valueChanged.emit()"></mat-checkbox>
    </div>
  }
}

@if (selectedField?.type === 'user') {
    @if (!compareBlank && !operator?.toLowerCase()?.includes('current') && !operator?.toLowerCase()?.includes('access')) {
      <div class="select-search-field">
          <select-filter
            (constant_changed)="rule.value = $event; valueChanged.emit()"
            [modelValue]="rule.value"
            [placeholder]="'Select user'"
            [is_user_options]="true">
          </select-filter>
      </div>
    }
}

@if (selectedField?.type === 'user_group') {
    @if (!compareBlank && !operator?.toLowerCase()?.includes('current') && !operator?.toLowerCase()?.includes('access')) {
      <div class="select-search-field">
          <select-filter
            (constant_changed)="rule.value = $event; valueChanged.emit()"
            [modelValue]="rule.value"
            [placeholder]="'Select user group'"
            [is_user_group_options]="true">
          </select-filter>
      </div>
    }
}

@if (selectedField?.type === 'account') {
    @if (!compareBlank && !operator?.toLowerCase()?.includes('current') && !operator?.toLowerCase()?.includes('access')) {
      <div class="select-search-field">
          <select-filter
            (constant_changed)="rule.value = $event; valueChanged.emit()"
            [modelValue]="rule.value"
            [placeholder]="'Select account'"
            [is_account_options]="true">
          </select-filter>
      </div>
    }
}
